














import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * AKTUALISIEREN in an IRES Admin Client list's sticky header: the red text button from 600 px, a red
 * refresh icon with the same name (tooltip, aria-label) on phones, where the text button wrapped the
 * header onto extra lines (Taimoor, 2026-11-03). Disabled, never spinning, while the screen loads.
 */
@Component
export default class AdminRefreshButtonComponent extends Vue {
  @Prop({ type: Boolean, default: false })
  disabled!: boolean;
}
